import apiClient from "../core/apiClient";
import { PasswordChangeRequest, UserPasswordDTO } from "../interfaces/DTO/userPassword";


// מחלקת UserPasswordService
class UserPasswordService {
  private readonly API_URL = "/passwords";

  /**
   * יצירת סיסמה חדשה למשתמש
   * @param data פרטי הסיסמה החדשה
   * @returns אובייקט UserPasswordDTO שנוצר
   */
  async createPassword(data: UserPasswordDTO): Promise<UserPasswordDTO> {
    try {
      const response = await apiClient.post<UserPasswordDTO>(`${this.API_URL}/create`, data);
      return response.data;
    } catch (error) {
      console.error("Failed to create password:", error);
      throw error;
    }
  }

  /**
   * שינוי סיסמה למשתמש לפי שם משתמש
   * @param data פרטי הבקשה לשינוי סיסמה
   * @returns האם שינוי הסיסמה הצליח
   */
  async changePassword(data: PasswordChangeRequest): Promise<boolean> {
    try {
      const response = await apiClient.put<boolean>(`${this.API_URL}/change-password`, data);
      return response.data;
    } catch (error) {
      console.error("Failed to change password:", error);
      throw error;
    }
  }
}

// ייצוא מחלקת ה-Service
export const userPasswordService = new UserPasswordService();
